module.exports = __webpack_public_path__ + "static/media/martin_jicha_jr.15b10927.jpg";